/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:d841c866-21da-416d-aefa-1af74a15bc80",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_pGZW2oXsk",
    "aws_user_pools_web_client_id": "1qvk2t80ho039ar8dpite11cd2",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "snmdreactrecordingbucketdd1e0-dev",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "PccPatients-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "AccountRequests-dev",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://f6b2wxljcrcg7b4q5pfiqms6qy.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-h3w2buqsgneydgzspuogjmcn2i",
    "aws_cloud_logic_custom": [
        {
            "name": "pccapi",
            "endpoint": "https://3479d2quo2.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "accountRequestsAPI",
            "endpoint": "https://gujk7dmmec.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_content_delivery_bucket": "snmdreact-20250528195853-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d3bbwrnpq30305.cloudfront.net"
};


export default awsmobile;
